import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "appshell",
    redirect: "/home",
    component: () => import("../views/appShell.vue"),
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("../views/home.vue"),
        meta: {
          requiresAuth: true,
          desc: "Inicio",
        },
      },
      {
        path: "carga_adet",
        name: "carga_adet",
        component: () => import("../views/carga_adet.vue"),
        meta: {
          requiresAuth: true,
          desc: "CARGA ADET",
        },
      },
    ],
  },
  {
    path: "/",
    name: "dialogshell",
    component: () => import("../views/dialogShell.vue"),
    children: [
      {
        path: "login",
        name: "login",
        component: () => import("../views/login.vue"),
        meta: {
          desc: "Login",
        },
      },
      {
        path: "logout",
        name: "logout",
        component: () => import("../views/logout.vue"),
        meta: {
          desc: "Logout",
        },
      },
      {
        path: "noaccess",
        name: "noaccess",
        component: () => import("../views/noaccess.vue"),
        meta: {
          desc: "Noaccess",
        },
      },
      {
        path: "/:catchAll(.*)",
        name: "nofound",
        component: () => import("../views/nofound.vue"),
        meta: {
          desc: "Nofound",
        },
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
  if (to.name !== "login" && requiresAuth && !store.state.user)
    next({
      name: "login",
    });
  else next();
});

export default router;
